import { render, staticRenderFns } from "./QualityControlPanel.vue?vue&type=template&id=c1547ea6&scoped=true"
import script from "./QualityControlPanel.vue?vue&type=script&lang=js"
export * from "./QualityControlPanel.vue?vue&type=script&lang=js"
import style0 from "./QualityControlPanel.vue?vue&type=style&index=0&id=c1547ea6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1547ea6",
  null
  
)

export default component.exports